import { useTranslations } from 'next-intl'

interface SizeNoteProps {
  sizeType?: string
}

export const SizeNote = ({ sizeType }: SizeNoteProps) => {
  const t = useTranslations('product_detail.instruction_size')

  let note: string[] | null = null
  if (sizeType) {
    try {
      const rawNote = t.raw(`size_note_by_category.${sizeType}`)
      if (Array.isArray(rawNote)) {
        note = rawNote
      } else if (typeof rawNote === 'object' && rawNote !== null) {
        note = Object.values(rawNote)
      }
    } catch (error) {
      // Key does not exist, note remains null.
    }
  }


  if (!note) {
    return null
  }

  return (
    <div className='mt-3 rounded bg-neutral-200 px-4 py-3 text-sm leading-5 text-neutral-800 opacity-90'>
      <div className='font-semibold'>{t('size_note.title')}</div>
      <ul className='ml-5 list-disc'>
        {note.map((item: string, index: number) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  )
}
